export const VTMN_TOGGLE_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
};
